import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';
import {UtilConfig} from 'app/autenticacion/servicios/UtilConfig';
import {LogEmisor} from "../../transaccion/logEmisorTmp/recursos/modelo/LogEmisor";
import {ConsumerService} from "../../../recursos/servicio/consumer.service";
// @ts-ignore
import {jsPDF} from "jspdf";
// @ts-ignore
import * as printJS from "print-js"
import {Router} from "@angular/router";
import * as moment from "moment";

declare var $: any;
declare var swal: any;

@Component({
    selector: 'app-summary',
    templateUrl: './view/summary.component.html',
    styleUrls: ['./css/summary.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SummaryComponent implements OnInit {
    @Input() logSeleccionado = new LogEmisor();
    @Input() cargaDocumentos = false;
    @Input() messageCreation = '';
    @Input() name = '';
    @Input() documentString = '';
    @Output() refresh = new EventEmitter<boolean>();
// VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_LOG_DESCARGAR_PDF: false,
        ROLE_LOG_DESCARGAR_RAR: false,
        ROLE_LOG_DESCARGAR_EXCEL: false,
        ROLE_LOG_DESCARGAR_CDR: false,
        ROLE_LOG_DESCARGAR_XML: false,
        ROLE_LOG_DESCARGAR_JSON: false,
    };

    constructor(private util: UtilConfig,
                private router: Router,
                private consumerService: ConsumerService,
                private cd: ChangeDetectorRef) {
        this.authorities = util.verificarAuthorities(this.authorities);


    }

    ngOnInit(): void {

    }


    async createPdf() {
        this.cd.markForCheck();
        this.cd.detectChanges();
        const div = document.getElementById('contenedor-ticket');
        const weight = 226.08;
        let heigtPixels = 500;
        if (div.offsetHeight > heigtPixels) {
            heigtPixels = div.offsetHeight + 10;
        }
        const pdf = new jsPDF("p", "pt", [weight, heigtPixels]);
        await pdf.html(div);
        printJS({
            printable: pdf.output('bloburl'),
            type: 'pdf',
            onPrintDialogClose: function () {
                window.close();
            }
        });
    }


    resetDocument() {
        this.refresh.emit(true);
    }


    goReady() {
        setTimeout(() => {
            const filtroList: any = {};
            let rangeDates: Date[];
            // RANGO FECHA
            rangeDates = [new Date(), new Date()];
            filtroList.tipoFecha = 'SUBIDA';
            filtroList.inicio = moment(rangeDates[0]).format('MM/DD/YYYY');
            filtroList.fin = moment(rangeDates[1]).format('MM/DD/YYYY');
            filtroList.documentType = this.documentString;
            filtroList.estadoRegistro = 'TODAS';
            filtroList.search = '1';
            $('ul#slide-out').removeClass('open');
            $('i.cerrarAleta').removeClass('open');
            $('.closePopupNotaDebito').click();
            this.router.navigate(['/content', {outlets: {'second': ['logEmisorV2', filtroList]}}]);
        }, 2000);
        this.cd.markForCheck();
        this.cd.detectChanges();
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/emisorFacturas/summary/summary.component.ts